import {
  textElementSchema,
  linksElementSchema,
  listElementSchema,
} from '../../../schema/pageElements.val';
import { pageMetadataSchema } from '../../../schema/pageMetadata.val';
import { c, nextAppRouter, s, t } from '../../../val.config';
import pageVal from './[slug]/page.val';

export const schema = s.object({
  subheader: s.string(),
  header: s.string(),
  links: s.array(s.keyOf(pageVal)),
  pageElements: s.array(
    s.union('type', textElementSchema, linksElementSchema, listElementSchema)
  ),
  pageMetadata: pageMetadataSchema,
});

export type ArbeiderPage = t.inferSchema<typeof schema>;

export default c.define(
  '/app/(main)/arbeider/page.val.ts',
  s.router(nextAppRouter, schema),
  {
    '/arbeider': {
      header: 'Arbeider',
      subheader: 'Ta en titt på noen av prosjektene vi har gjort i det siste',
      links: [
        '/arbeider/aneo',
        '/arbeider/bi',
        '/arbeider/ice',
        '/arbeider/remarkable',
        '/arbeider/aidn',
        '/arbeider/wewillwrite',
        '/arbeider/finn',
        '/arbeider/hjemmelegene',
        '/arbeider/morgenlevering',
        '/arbeider/krf',
        '/arbeider/bboy',
        '/arbeider/sas-skien',
        '/arbeider/amoi',
        '/arbeider/reisen-til-spektrum',
      ],
      pageElements: [
        {
          type: 'listElement',
          title: 'Andre vi har jobbet med',
          list: [
            'Autopay',
            'Aidn',
            'Airthings',
            'Aize',
            'AMOI',
            'Aneo Mobility',
            'ANEO',
            'ANTI',
            'Autodesk',
            'Bærum Kommune',
            'Bildeler.no',
            'Brønnøysundregistrene',
            'Buypass',
            'Be Your Best',
            'Cartopia',
            'Color Line',
            'Crowdworks AS',
            'Deichmanske bibliotek',
            'Distribution Innovation',
            'Eika',
            'Elbits',
            'Equality Check AS',
            'Finn',
            'Firesafe',
            'Flytoget',
            'Folq AS',
            'Fortum',
            'Function',
            'Giant Leap',
            'Gjensidige',
            'Gyldendal',
            'Handelens Miljøfond',
            'Handelshøyskolen BI',
            'Hjemmelegene',
            'HR Manager - Talentech',
            'Huddly',
            'ice',
            'Imerso',
            'Inevo',
            'Inspera',
            'IXDA OSLO',
            'Kristelig Folkeparti',
            'Little Big Sister',
            'LINK Mobility',
            'MER',
            'Morgenlevering',
            'NAV',
            'NODESmarket',
            'NRK',
            'Norwegian Subsea',
            'Norges Seilforbund',
            'Norsk Tipping',
            'Norges Verdensarv',
            'ODA',
            'Ohlogy',
            'Opus Systemer AS',
            'Oslo Kommune',
            'Otovo',
            'Play Magnus',
            'Posten',
            'Raa Labs',
            'Reddel',
            'REMA1000',
            'reMarkable',
            'Ruter',
            'Schibsted',
            'Sparebank1',
            'Searis',
            'Sector Alarm',
            'Sesong1',
            'Shortshift',
            'Snøhetta',
            'Soolv',
            'Spacemaker',
            'Statsbygg',
            'Stein Halvorsen Arkitekter',
            'Storebrand',
            'Stortinget',
            'Svosj',
            'Take Take Take',
            'TDC',
            'Telia',
            'TESS',
            'TET Digital AS',
            'Thales',
            'Telenor',
            'Tripletex',
            'Unacast',
            'Vend',
            'Viasat',
            'Visma',
            'WeWillWrite',
          ],
        },
        {
          type: 'linksElement',
          links: [
            { text: 'Bli kjent med folkene våre', href: '/menneskene' },
            {
              text: 'Les mer om hvordan det er å jobbe i Blank',
              href: '/jobb',
            },
            { text: 'Hva kan vi gjøre for deg', href: '/tjenester' },
          ],
        },
      ],
      pageMetadata: {
        title: 'Arbeider',
        description: 'Våre arbeider',
        image: {
          path: '/public/val/images/dbcb029cf591f7424afeba3f21cbf7f641e704ba-3500x2333.webp',
          width: 3500,
          height: 2333,
          mimeType: 'image/webp',
          alt: 'Fest på loftet',
        },
      },
    },
  }
);
